module.exports = __webpack_public_path__ + "img/logo.49dad5e3.png";